import InlineEditor from "./InlineEditor";

export default InlineEditor;
